<template>
    <div class="rounded-lg bg-white dark:bg-gray-700 text-black dark:text-white p-3 shadow">
        <p class="mb-4">* Linked Pages</p>
        <draggable
            handle=".handle"
            :value="linked_pages"
            @input="data => $emit('input', data)"
            @update="updateOrder"
            ghost-class="opacity-50"
            @choose="froalaStore.disableFroala = true"
            @unchoose="froalaStore.disableFroala = false"
        >
            <div
                v-for="(page, index) in linked_pages"
                :key="`page_${index}`"
                class="rounded-lg bg-white dark:bg-gray-700 shadow mb-4 relative"
            >
                <div
                    class="flex justify-between items-center cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-600 p-4"
                    @click="togglePageCollapse(index)"
                >
                    <div class="handle">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
                    </div>
                    <div>
                        {{ page.document ? page.document.name : null }}
                    </div>
                    <div>
                        <svg v-if="!page.collapsed" class="h-4 w-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                        <svg v-if="page.collapsed" class="h-4 w-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                        </svg>
                    </div>
                </div>

                <div class="px-4 pb-4" v-show="page.collapsed">
                    <div class="flex flex-row items-center justify-end mt-3">
                        <button
                            type="button"
                            class="bg-red-500 text-white flex flex-row items-center rounded px-3 py-2"
                            @click="deletePage(index)"
                            v-if="!fixedItemsCount"
                        >
                            <svg
                                class="w-4 h-4"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                />
                            </svg>
                            <span class="ml-2">Delete Linked Page</span>
                        </button>
                    </div>

                    <div
                        class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
                    >
                        <p class="text-gray-700 dark:text-gray-200 mb-4">Linked Page</p>
                        <polymorphic-reference
                            :creatable="false"
                            :deletable="true"
                            :linkable="true"
                            :language="language"
                            v-model="page.document"
                            :should-open-new-window="true"
                            :models="linkableTypes"
                            :query="{
                                status_id: 1,
                            }"
                            :error="errors[`linked_pages.${index}.document.id`] ? errors[`linked_pages.${index}.document.id`][0] : (errors[`linked_pages.${index}.document.model_name`] ? errors[`linked_pages.${index}.document.model_name`][0] : null)"
                        />
                    </div>
                </div>
            </div>
        </draggable>
        <Btn
            content="Add Linked Page"
            class="mt-3"
            type="button"
            @click="addPage"
            v-if="!fixedItemsCount"
        />

        <p v-if="errors.linked_pages" class="text-red-800 mt-2 text-sm">{{ errors.linked_pages[0] || '' }}</p>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import {useFroalaStore} from "../stores/froala";
export default {
    name: "ErrorPageLinkedPages",
    components: {draggable},
    props: {
        value: {
            type: Array,
            required: true,
        },
        errors: {
            type: [Array, Object],
            required: true,
        },
        fixedItemsCount: {
            type: Boolean,
            required: false,
            default: false,
        },
        language: Object,
        linkableTypes: {
            type: Array,
            default: () => [
                "Category",
                "Software Category",
                "Payment Category",
                "License Category",
                "Country Category",
                "Bonus Type Category",
                "Game Type Category",
                "Casino Review",
                "Slot Review",
                "Game Review",
                "Author",
                "About Us Page",
                "Payment Method Main Page",
                "License Main Page",
                "Knowledge Hub Page",
                "Blog Main Page",
                "Guide Main Page",
                "Home Page",
                "Legal Notice Page",
                "Privacy Policy Page",
                "Cookie Policy Page",
                "Responsible Gambling Page",
                "Blog",
                "Guide",
                "Html Sitemap",
            ],
        },
    },
    data: function(){
        return {
            linked_pages: this.value,
            froalaStore: useFroalaStore(),
        }
    },
    mounted: function(){
        this.linked_pages.map(page => {
            page.collapsed = false;
            return page;
        });
    },
    methods: {
        addPage: function(){
            this.linked_pages.push({
                key: Math.random().toString(16).substr(2, 8),
                document: null,
            });
            this.updateOrder();
        },
        deletePage: function(index){
            this.linked_pages.splice(index, 1);
            this.updateOrder();
        },
        updateOrder: function(){
            const linked_pages = [...this.linked_pages];
            this.linked_pages = linked_pages.map((page, index) => {
                page.order = index;
                return page;
            });
            this.$emit('input', this.linked_pages)
        },
        togglePageCollapse: function(pageIndex){
            const linked_pages = [...this.linked_pages];
            linked_pages[pageIndex].collapsed = !linked_pages[pageIndex].collapsed;
            this.linked_pages = linked_pages;
        },
    },
    watch: {
        value: function(newValue){
            this.linked_pages = newValue;
        }
    },

}
</script>
